<template>
  <div class="company-jobs-container">
    <TopButtonsComponent
      :jobCreatorId="creatorId"
      v-on:backToJobs="$emit('backToJobs', 'Jobs')"
      v-on:backToPostJob="$emit('backToPostJob', 'Post Job')"
      v-bind:isBusinessJobListPage="isBusinessJobListPage"
    />

    <div class="company-jobs">
      <div class="filter-holder">
        <FilterJob
          v-on:filterHandler="handleFilter"
          :firstTitle="'Status'"
          :secondTitle="'Specialization'"
          :firstOptions="firstOptions"
          :secondOptions="secondOptions"
          :firstSelectedValue="firstSelectedValue"
          :secondSelectedValue="secondSelectedValue"
        />
      </div>

      <div class="jobs-info-container" v-if="!loading">
        <div v-if="currentJobsList && currentJobsList.length > 0">
          <div
            class="job-item-container"
            v-for="job in currentJobsList"
            v-bind:key="job.id"
          >
            <div class="job-detail">
              <div class="job-detail-inner-wrapper">
                <p class="job-name">{{ job.title }}</p>
                <p class="job-location">
                  <span v-if="job.city">{{ job.city }}</span>
                  <span v-if="job.state">, {{ job.state }}</span>
                </p>
                <p class="job-company-name">{{ job.companyName }}</p>
                <p class="job-date" v-if="job.jobDeadline">{{ new Date(job.jobDeadline + 'T00:00:00').toDateString() }}</p>
                <p v-if="job.status === 'Active'" class="job-status-active">
                  {{ job.status }}
                </p>
                <p
                  v-if="job.status === 'Expired'"
                  class="job-status-expired"
                >
                  {{ job.status }}
                </p>
              </div>

              <!-- Options Menu for Mobile & Tablet View Only -->
                <div class="options-button-container show-only-mobile-tablet">
                  <div class="options-menu" v-if="showOptions === job.id">
                    <div class="options-menu-item"
                      @click="$emit('jobDetail', job.id)"
                    >
                      <img class="dark" src="../../assets/images/view-dark.svg" alt="view icon" />
                      <img class="light" src="../../assets/images/view-light.svg" alt="view icon" />
                      <div>View</div>
                    </div>

                    <div
                      class="options-menu-item"
                      @click="$emit('editJob', job.id)"
                      v-if="job.creator === creatorId || job.agencyCreator === creatorId"
                    >
                      <img class="dark" src="../../assets/images/edit-dark.svg" alt="edit icon" />
                      <img class="light" src="../../assets/images/edit-light.svg" alt="edit icon" />
                      <div>Edit</div>
                    </div>

                    <div
                      class="options-menu-item"
                      @click="generateCopyLink(job.id)"
                    >
                      <img class="dark" src="../../assets/images/view-dark.svg" alt="view icon" />
                      <img class="light" src="../../assets/images/view-light.svg" alt="view icon" />
                      <div>Share Job Link</div>
                    </div>

                    <div
                      class="options-menu-item"
                      @click="deleteJobHandler(job.id)"
                      v-if="job.creator === creatorId || job.agencyCreator === creatorId"
                    >
                      <img class="dark" src="../../assets/images/delete-dark.svg" alt="delete icon" />
                      <img
                        class="light"
                        src="../../assets/images/delete-light.svg"
                        alt="delete icon"
                      />
                      <div>Delete</div>
                    </div>

                    <!-- <div class="options-menu-item">
                      <img
                        class="dark"
                        src="../../assets/images/applications-dark.png"
                        alt="applications icon"
                      />
                      <img
                        class="light"
                        src="../../assets/images/applications-light.svg"
                        alt="applications icon"
                      />
                      <div>Applications</div>
                    </div> -->
                  </div>

                  <div v-on:click="openMenuOptions(job.id)" class="image-container" :id="job.id">
                    <img src="../../assets/images/dots-menu.svg" alt="options menu icon" />
                  </div>
                </div>
                <!-- End of Options Menu for Mobile & Tablet Device View -->
            </div>

            <div class="job-statuses-container">
              <div class="applications-status-container status-in-review">
                <p class="desc">In-review</p>
                <p class="count">{{ job.inReviewCount }}</p>
              </div>

              <div class="applications-status-container status-shortlisted">
                <p class="desc">Shortlisted</p>
                <p class="count">{{ job.shortlistedCount }}</p>
              </div>

              <div class="applications-status-container status-invited">
                <p class="desc">Invited for Interview</p>
                <p class="count">{{ job.scheduledForInterviewCount }}</p>
              </div>

              <div class="applications-status-container status-hired">
                <p class="desc">Hired</p>
                <p class="count">{{ job.hiredCount }}</p>
              </div>

              <div class="applications-status-container status-declined">
                <p class="desc">Declined</p>
                <p class="count">{{ job.declinedCount }}</p>
              </div>

              <div class="applications-status-container status-total">
                <p class="desc">Total Applications</p>
                <p class="count">{{ job.applications.length }}</p>
              </div>
            </div>

            <!-- Options Menu for Desktop View Only -->
            <div class="options-button-container show-only-desktop">
              <div class="options-menu" v-if="showOptions === job.id">
                <div class="options-menu-item"
                  @click="$emit('jobDetail', job.id)"
                >
                  <img class="dark" src="../../assets/images/view-dark.svg" alt="view icon" />
                  <img class="light" src="../../assets/images/view-light.svg" alt="view icon" />
                  <div>View</div>
                </div>

                <div
                  class="options-menu-item"
                  @click="$emit('editJob', job.id)"
                  v-if="job.creator === creatorId || job.agencyCreator === creatorId"
                >
                  <img class="dark" src="../../assets/images/edit-dark.svg" alt="edit icon" />
                  <img class="light" src="../../assets/images/edit-light.svg" alt="edit icon" />
                  <div>Edit</div>
                </div>

                <div
                  class="options-menu-item"
                  @click="generateCopyLink(job.id)"
                >
                  <img class="dark" src="../../assets/images/view-dark.svg" alt="view icon" />
                  <img class="light" src="../../assets/images/view-light.svg" alt="view icon" />
                  <div>Share Job Link</div>
                </div>

                <div
                  class="options-menu-item"
                  @click="deleteJobHandler(job.id)"
                  v-if="job.creator === creatorId || job.agencyCreator === creatorId"
                >
                  <img class="dark" src="../../assets/images/delete-dark.svg" alt="delete icon" />
                  <img
                    class="light"
                    src="../../assets/images/delete-light.svg"
                    alt="delete icon"
                  />
                  <div>Delete</div>
                </div>

                <!-- <div class="options-menu-item">
                  <img
                    class="dark"
                    src="../../assets/images/applications-dark.png"
                    alt="applications icon"
                  />
                  <img
                    class="light"
                    src="../../assets/images/applications-light.svg"
                    alt="applications icon"
                  />
                  <div>Applications</div>
                </div> -->
              </div>

              <div v-on:click="openMenuOptions(job.id)" class="image-container" :id="job.id">
                <img src="../../assets/images/dots-menu.svg" alt="options menu icon" />
              </div>
            </div>
            <!-- End of Options Menu for Desktop View Only -->

          </div>
        </div>

        <EmptyDashboardState
          v-else-if="!currentJobsList.length && this.jobsList && this.jobsList.length < 1"
          v-bind:emptyHeading="'Jobs'"
          v-bind:desc="'No Search Result Found'"
        />

        <EmptyDashboardState
          v-else
          v-bind:emptyHeading="'No Jobs Yet'"
          v-bind:desc="'Start by Creating a Job'"
        />

      </div>
    </div>

    <div v-if="currentJobsList && currentJobsList.length > 0" class="pagination-wrapper">
      <Pagination
        v-bind:itemsPerPage="itemsPerPage"
        v-bind:totalJobs="jobsList.length"
        v-bind:currentPage="currentPage"
        v-on:paginate="paginate"
      />
    </div>

    <!-- Modal component for actions confirmation -->
    <div v-if="showModal">
      <ActionModal
        :verb="modalVerb"
        :subject="modalSubject"
        v-on:modalAction="modalAction"
      />
    </div>

    <!-- Loader Component -->
    <Loader
      v-if="loading"
    />
  </div>
</template>

<script>
import Pagination from '../Pagination.vue';
import ActionModal from '../Modals/ActionModal.vue';
import TopButtonsComponent from '../JobDetail/TopButtonsComponent.vue';
import FilterJob from '../body/FilterJob.vue';
import Loader from '../body/Loader.vue';
import EmptyDashboardState from '../EmptyDashboardState.vue';

export default {
  name: 'CompanyJobsLst',
  components: {
    ActionModal,
    Pagination,
    TopButtonsComponent,
    FilterJob,
    Loader,
    EmptyDashboardState
  },
  props: ['jobCreatorId', 'companyJobsList', 'isBusinessJobListPage'],
  data() {
    return {
      firstOptions: [
        { id: 1, name: 'All Status', value: 'allStatus', selected: true },
        { id: 2, name: 'Active', value: 'Active' },
        { id: 3, name: 'Expired', value: 'Expired' },
      ],
      secondOptions: [
        { name: 'All Specialization', value: 'allSpecialization', selected: true },
        { name: 'Technology', value: 'Technology' },
        { name: 'Education', value: 'Education' },
        { name: 'Product Design', value: 'Product Design' },
        { name: 'Product Management', value: 'Product Management' },
        { name: 'Project Management', value: 'Project Management' },
        { name: 'Administration', value: 'Administration' },
        { name: 'Operations', value: 'Operations' },
        { name: 'Sales', value: 'Sales' },
        { name: 'Marketing', value: 'Marketing' },
        { name: 'Customer Service', value: 'Customer Service' },
        { name: 'Human Resources', value: 'Human Resources' },
        { name: 'Creative & Design', value: 'Creative and Design' },
        { name: 'Media & Communications', value: 'Media and Communications' },
        { name: 'Health & Wellness', value: 'Health and Wellness' },
        { name: 'Hospitality & Tourism', value: 'Hospitality and Tourism' },
        { name: 'Arts & Entertainment', value: 'Arts and Entertainment' },
        { name: 'Science & Research', value: 'Science and Research' },
        { name: 'Agriculture', value: 'Agriculture' },
        { name: 'Finance', value: 'Finance' },
        { name: 'Supply Chain', value: 'Supply Chain' },
        { name: 'Engineering', value: 'Engineering' },
        { name: 'Building & Construction', value: 'Building and Construction' },
        {
          name: 'Logistics & Transportation',
          value: 'Logistics and Transportation',
        },
        { name: 'Legal', value: 'Legal' },
        { name: 'Energy & Utilities', value: 'Energy and Utilities' },
        { name: 'Telecommunications', value: 'Telecommunications' },
        {
          name: 'Petroleum & Petrochemicals',
          value: 'Petroleum and Petrochemicals',
        },
        {
          name: 'Furniture & Interior Design',
          value: 'Furniture and Interior Design',
        },
        { name: 'Manufacturing', value: 'Manufacturing' },
        { name: 'Healthcare', value: 'Healthcare' },
        { name: 'Others', value: 'Others' },

      ],
      firstSelectedValue: 'allStatus',
      secondSelectedValue: 'allSpecialization',

      showModal: false,
      modalSubjectId: null,
      modalVerb: null,
      modalSubject: null,

      loading: false,
      jobsArrayLength: 0,
      hideMenuOptions: true,

      selectedStatus: 'All Status',
      selectedCategory: 'All',

      jobsList: this.companyJobsList,
      currentPage: 1,
      itemsPerPage: 10,
      isFiltered: false,
      filteredList: [],
      showOptions: null,
      creatorId: this.jobCreatorId,
    };
  },
  methods: {
    async modalAction(value) {
      //toggle modal
      this.showModal = !this.showModal;
      // decide action
      switch (true) {
        case (this.modalSubject === 'job' && this.modalVerb === 'delete'):
            value === 'yes' ?
              this.sendDispatchCall('deleteJob', this.modalSubjectId)
              : this.closeModal();
          break;

        default:
          break;
      }
    },
    closeModal () {
      this.showModal = false;
      this.modalVerb = null;
      this.modalSubject = null;
      this.modalSubjectId = null;
    },
    deleteJobHandler(id) {
      this.showModal = !this.showModal;
      this.modalSubjectId = id;
      this.modalVerb = 'delete';
      this.modalSubject = 'job';
      this.closeMenuOptions();
    },
    sendDispatchCall(dispatchAction, entityId) {
      this.loading = true;
      this.$store.dispatch(dispatchAction, entityId)
          .then((res) => {
            if(res.response) {
              this.$toastr.success(res.response ? res.response.message : res.response, 'Success');
              this.$router.go();
              this.loading = false;
            } else if(res.error) {
              this.$toastr.error(
                res.error.error ? res.error.error
                : res.error ? res.error.message
                : res.error,
                'Failed'
              );
              this.loading = false;
            }
            this.closeModal();
          });
    },
    openMenuOptions(id) {
      id !== this.showOptions ?
      this.showOptions = id : this.closeMenuOptions();
    },
    closeMenuOptions() {
      this.showOptions = null;
    },
    generateCopyLink(id){
      // Construct the job link URL bearing in mind that .env url value includes the trailing slash
      const url = `${process.env.VUE_APP_BASE_URL}user/jobs/${id}/share`;
      const el = document.createElement('textarea');

      el.value = url;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();

      let success = document.execCommand('copy');
      success
      ? this.$toastr.success('Link copied to clipboard!', 'Success')
      : this.$toastr.error('Unable to copy link to clipboard', 'Error');

      this.closeMenuOptions();
    },
    paginate(pageNumber) {
      this.currentPage = pageNumber;
    },
    handleFilter(option) {
      this.currentPage = 1;

      // Start with all jobs
      let filteredJobs = [...this.companyJobsList];

      const { firstOption, secondOption } = option;

      // --- STATUS FILTER ---
      if (firstOption && firstOption !== 'allStatus') {
        filteredJobs = filteredJobs.filter(job => job.status === firstOption);
      }

      // --- CATEGORY/SPECIALIZATION FILTER ---
      if (secondOption && secondOption !== 'allSpecialization') {
        filteredJobs = filteredJobs.filter(job => job.category === secondOption);
      }

      // Update the jobs list
      this.jobsList = filteredJobs;

      return filteredJobs;
    },
    multiFilterHandler(option) {
      this.currentPage = 1;

      // Start with all jobs
      let filteredJobs = [...this.companyJobsList];

      // Map filter keys to job fields and their "all" values
      const filterConfig = {
        firstOption: { field: 'status', allValue: 'allStatus' },
        secondOption: { field: 'category', allValue: 'allSpecialization' }
      };

      // Apply all filters dynamically
      for (const [optionKey, config] of Object.entries(filterConfig)) {
        const selectedValue = option[optionKey];

        if (!selectedValue) continue; // skip null/undefined/empty

        // Support multi-select (array) or single value
        const valuesToFilter = Array.isArray(selectedValue) ? selectedValue : [selectedValue];

        // Skip if it contains the "all" value
        if (valuesToFilter.includes(config.allValue)) continue;

        // Apply filter
        filteredJobs = filteredJobs.filter(job => valuesToFilter.includes(job[config.field]));
      }

      this.jobsList = filteredJobs;

      return filteredJobs;
    }
  },
  computed: {
    indexOfLastJob() {
      return this.currentPage * this.itemsPerPage;
    },

    indexOfFirstJob() {
      return this.indexOfLastJob - this.itemsPerPage;
    },

    currentJobsList() {
      return this.jobsList.slice(this.indexOfFirstJob, this.indexOfLastJob);
    },
  },

  beforeUpdate() {},
};
</script>

<style scoped>
/* Hide Table Options for mobile-only screens */
  .show-only-mobile-tablet{
    display: none !important;
  }
  .company-jobs {
    display: flex;
    flex-direction: column;
    background: white;
    border-radius: 10px;
    box-shadow: 0px 14px 24px rgba(9, 44, 76, 0.1);
  }
  .company-jobs-heading {
    padding: 3.125rem 0;
    display: flex;
    align-items: center;
  }
  .company-jobs-heading .select-container {
    margin: 0 3.625rem;
    font-weight: 600;
    line-height: 19.5px;
    font-size: 1rem;
    color: var(--colorPrimary);
    width: 20%;
  }
  .select-container p {
    margin-bottom: 16px;
  }
  .select-container select {
    padding: 10px;
    border: none;
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    border-radius: 3px;
    padding: 10px 0 10px 17px;
    width: 100%;
  }
  .company-jobs-heading button {
    padding: 10px 57px;
    border-radius: 5px;
    border: none;
    background: var(--colorPrimary);
    color: var(--white);
    font-size: 17px;
  }
  .filter-holder {
    padding: 0 1.7rem;
  }
  .job-item-container {
    display: flex;
    border-top: 0.5px solid #c9c9c9;
  }
  .job-statuses-container {
    display: flex;
    flex-wrap: wrap;
  }
  .job-item-container .job-detail {
    text-transform: capitalize;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    padding: 2.688rem 3.625rem 2.5rem 3.625rem;
  }
  .job-detail .job-detail-inner-wrapper {
    width: 150px;
  }
  .job-detail p {
    margin-bottom: 14px;
  }
  .job-name {
    font-size: 1.125rem;
    font-weight: 700;
    color: var(--black);
    line-height: 1.375rem;
    text-transform: capitalize;
  }
  .job-location {
    font-weight: 500;
    color: #828282;
    line-height: 1.125rem;
    font-size: 0.938rem;
  }
  .job-company-name {
    color: #252525;
    font-weight: 800;
    font-size: 1.063rem;
    line-height: 1.313rem;
  }
  .job-name, .job-company-name {
    word-break: break-word;
  }
  .job-date {
    font-size: 1rem;
    color: var(--colorSecondary);
  }
  .job-status-active,
  .job-status-expired {
    font-weight: bold;
    font-size: 1rem;
    line-height: 1.25rem;
  }
  .job-status-active {
    color: #27ae60;
  }
  .job-status-expired {
    color: #df2029;
  }
  .applications-status-container {
    text-align: center;
    border-radius: 15px;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 2.688rem 25px 2.5rem 0;
    padding: 15px 32px;
    width: 150px;
    height: 160px;
  }
  .applications-status-container .desc {
    font-size: 16px;
    font-weight: 600;
    line-height: 21.94px;
  }
  .applications-status-container .count {
    font-size: 28px;
    font-weight: 600;
    line-height: 39.01px;
  }
  .status-in-review {
    border: 1px solid #767676;
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
  }
  .status-in-review .count {
    color: #767676;
  }
  .status-shortlisted {
    border: 1px solid #ffb300;
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
  }
  .status-shortlisted .count {
    color: #ffb300;
  }
  .status-invited {
    border: 1px solid var(--colorSecondary);
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
  }
  .status-invited .count {
    color: var(--colorSecondary);
  }
  .status-hired {
    border: 1px solid #27ae60;
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
  }
  .status-hired .count {
    color: #27ae60;
  }
  .status-declined {
    border: 1px solid #df2029;
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
  }
  .status-declined .count {
    color: #df2029;
  }
  .status-total {
    border: 1px solid #4870c0;
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
  }
  .status-total .count {
    color: #4870c0;
  }
  .options-button-container {
    position: relative;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    margin-right: 40px;
  }
  .options-menu {
    /* display: none; */
    background: var(--white);
    position: absolute;
    right: 40px;
    width: 190px;
    box-shadow: 0px 8px 11px rgba(43, 61, 110, 0.07);
    border-radius: 5px;
  }
  .hide-options {
    display: none;
  }
  .show-options-container .options-menu {
    display: block;
  }
  .options-menu-item {
    cursor: pointer;
    width: 100%;
    align-items: center;
    display: flex;
    padding: 12px;
    font-size: 14px;
  }
  .options-menu-item:hover {
    width: 100%;
    align-items: center;
    display: flex;
    padding: 12px;
    background: var(--colorPrimary);
    color: var(--white);
  }
  .options-menu-item .light {
    display: none;
  }
  .options-menu-item:hover .dark {
    display: none;
  }
  .options-menu-item:hover .light {
    display: block;
  }
  .options-menu-item img {
    width: 14px;
    margin-right: 14px;
  }
  .image-container {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    border-radius: 100%;
  }
  .options-button img {
    width: 20px;
    height: 20px;
    object-fit: cover;
  }
  .pagination-wrapper {
    margin-top: 31px;
    display: flex;
    justify-content: flex-end;
  }

  /* RESPONSIVE DESIGN */

  @media only screen and (min-width: 1881px) {
    .job-item-container .job-detail {
      margin-right: 50px;
    }
  }
  @media only screen and (max-width: 1178px) {
    .company-jobs-heading {
      padding: 3.125rem;
      display: grid;
      grid-template-columns: 1fr 1fr;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
    }
    .company-jobs-heading .select-container {
      margin: 1.5rem 0;
      font-weight: 500;
      line-height: 16px;
      font-size: 1rem;
      color: var(--colorSecondary);
      width: 50%;
    }
    .company-jobs-heading button {
      padding: 10px 57px;
      border-radius: 5px;
      border: none;
      background: var(--colorPrimary);
      color: var(--white);
      font-size: calc(17px / 1.5);
    }
    .applications-status-container .desc {
      font-size: calc(18px / 1.5);
      font-weight: 600;
      line-height: calc(21.94px / 1.5);
    }
    .applications-status-container .count {
      font-size: 24px;
      font-weight: 600;
      line-height: 39.01px;
    }
  }
  @media only screen and (max-width: 1154px) {
    .applications-status-container {
      margin: 2rem 25px 2rem 0;
      width: 130px;
      height: 90px;
    }
  }
  @media only screen and (max-width: 1081px) {
    .job-item-container .job-detail {
      padding: 2rem 2rem 2rem 3.625rem;
    }
  }
  @media only screen and (max-width: 1049px) {
    .job-item-container {
      flex-direction: column;
    }
    .job-item-container .job-detail {
      flex-direction: row;
      justify-content: space-between;
    }
    .job-detail .job-detail-inner-wrapper {
      width: unset;
    }
    .job-statuses-container {
      padding: 0 2rem 2rem 3.625rem;
      justify-content: center;
    }
    .applications-status-container {
      width: 150px;
    }
    /* Display respective options on list depending on the screen size */
    .show-only-desktop {
      display: none;
    }
    .show-only-mobile-tablet {
      display: block !important;
    }
    .options-button-container.show-only-mobile-tablet {
      margin-right: 0;
      align-self: auto;
      width: unset;
      height: 20px;
    }
  }
  @media only screen and (max-width: 990px) {
    .company-jobs-heading {
      padding: 3.125rem;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      text-align: center;
    }
  }
  @media only screen and (max-width: 767px) {
  }
  @media only screen and (max-width: 650px) {
    .job-item-container {
      flex-direction: column;
      padding-bottom: 2.688rem;
    }
    .job-statuses-container {
      justify-content: center;
    }
    .applications-status-container {
      height: 120px;
    }
  }
  @media only screen and (max-width: 565px) {
  }
  @media only screen and (max-width: 420px) {
    .applications-status-container {
      height: 100px;
    }
  }
</style>
